import { render } from "./tw-ws-radar.vue?vue&type=template&id=21feb3be"
import script from "./tw-ws-radar.vue?vue&type=script&lang=js"
export * from "./tw-ws-radar.vue?vue&type=script&lang=js"
script.render = render

export default script